import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Recibirás un correo electrónico inmediatamente después de tu compra con los enlaces de acceso y descarga a todo el material digital.'
}, {
  q: '¿Es de acceso inmediato?',
  a: 'Sí, el acceso es automático e inmediato una vez confirmado el pago.'
}, {
  q: '¿Está pensado para uso profesional?',
  a: 'Absolutamente. Todo el contenido fue diseñado específicamente para fonoaudiólogos/as que buscan optimizar su práctica clínica.'
}, {
  q: '¿La oferta de $19.990 incluye tomos y bonos?',
  a: 'Sí, la Oferta Base incluye los 6 tomos principales y los 6 bonos digitales.'
}, {
  q: '¿Qué diferencia hay con la opción de $27.990?',
  a: 'La opción Premium de $27.990 incluye todo lo de la base, MÁS contenido extra exclusivo, mayor profundidad en los temas y herramientas avanzadas. Es la opción que elige la mayoría para tener la biblioteca más completa.'
}, {
  q: '¿Cuál conviene más?',
  a: 'Recomendamos fuertemente la opción de $27.990. Por una pequeña diferencia de precio, te llevas el paquete completo y definitivo, asegurando que no te falte ninguna herramienta en tu práctica.'
}, {
  q: '¿El material es digital?',
  a: 'Sí, todo el MegaPack es 100% digital, listo para descargar, imprimir o usar desde tus dispositivos.'
}, {
  q: '¿Se paga una sola vez?',
  a: 'Sí, es un pago único. No hay suscripciones ni cobros mensuales ocultos.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-8 bg-transparent" data-id="element-52">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-53">
        <div className="text-center mb-16" data-id="element-54">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-55">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-56">
          {faqs.map((faq, i) => <div key={i} className={`glass-card rounded-2xl overflow-hidden transition-colors ${openIndex === i ? 'border-orange-500/50' : 'border-white/5 hover:border-white/20'}`} data-id="element-57">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-58">
                <span className="font-bold text-white pr-8" data-id="element-59">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-orange-500 shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-60" />
              </button>

              <AnimatePresence data-id="element-61">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-62">
                    <div className="px-6 pb-5 text-gray-400 leading-relaxed" data-id="element-63">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}